var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPrintReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "no-print-receipt",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9992 2.4L31.1992 0.5L26.5992 5.1L21.9992 0.5L20.1992 2.4L24.6992 6.9L20.1992 11.5L21.9992 13.3L26.5992 8.8L31.1992 13.3L32.9992 11.5L28.3992 6.9L32.9992 2.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 25.7016C25.3 26.9016 24.3 27.9016 23.2 27.9016H9C9.3 27.2016 9.5 26.5016 9.5 25.7016V12.7016V7.40156L11.3 8.70156L14.4 6.40156L17.7 8.90156L19.3 6.80156L14.4 3.10156L11.3 5.40156L6.9 2.10156V12.7016H0V25.7016C0.1 27.0016 0.6 28.2016 1.6 29.0016C2.5 29.8016 3.6 30.2016 4.7 30.2016V30.5016H23.1C25.7 30.5016 27.9 28.3016 27.9 25.7016V15.3016H25.3V25.7016ZM2.6 25.7016V15.3016H6.9V25.6016C6.8 26.7016 6 27.6016 4.9 27.6016C4.3 27.6016 3.8 27.4016 3.4 27.1016C2.9 26.8016 2.6 26.2016 2.6 25.7016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 16.1992H11.5V18.7992H23.3V16.1992Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 20.8984H11.5V23.4984H23.3V20.8984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPrintReceipt);
export default __webpack_public_path__ + "static/media/no-print-receipt.c3f9dd2b2402b5e1f957b6f21a445c78.svg";
export { ForwardRef as ReactComponent };